import React from 'react';
import { observer } from 'mobx-react';
import { animateScroll as scroll } from 'react-scroll';

import {
  Wrapper,
  Helper,
  Arrow,
  ArrowText,
} from './style';

import AppState from '../../states/AppState';
import IntroCloudState from '../../states/IntroCloudState';

const ScrollPrompt = () => AppState.regularMode && IntroCloudState.showHelper ? (
  <Wrapper
    className={AppState.scrollTop > 5 ? 'inactive' : 'active'}
    onClick={evt => {
      evt.preventDefault();
      const el = document.getElementsByName("Introduction")[0];
      const box = el.getBoundingClientRect();
      scroll.scrollMore(box.top + 1);
    }}
  >
    <Helper>Click or drag to explore the cloud, then scroll down to read the full report.</Helper>
  </Wrapper>
) : (
  <Wrapper
    className={AppState.scrollTop > 5 ? 'inactive' : 'active'}
    onClick={evt => {
      evt.preventDefault();
      const el = document.getElementsByName("Introduction")[0];
      const box = el.getBoundingClientRect();
      scroll.scrollMore(box.top + 1);
    }}
  >
    <ArrowText>Explore the Year in Fashion<Arrow>&darr;</Arrow></ArrowText>
  </Wrapper>
);

export default observer(ScrollPrompt);



// WEBPACK FOOTER //
// ./src/components/ScrollPrompt/index.js